<template>
  <transition name="popup">
    <div class="share-container" v-if="showFlag" @click="hideFn">
      <img src="../../assets/images/share.png" class="share-img" @click.passive="imgFn">
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Share',
  data () {
    return {
      showFlag: false
    }
  },
  methods: {
    showFn () {
      this.showFlag = true
    },
    hideFn () {
      this.showFlag = false
    },
    imgFn () {
      return false
    }
  }
}
</script>

<style scoped>
.share-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .8);
  transition-duration: .4s;
}
.share-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.popup-enter-active,
.popup-leave-active {
  transition: opacity .4s cubic-bezier(0.32, 0.08, 0.24, 1);
}
.popup-enter,
.popup-leave-to {
  opacity: 0;
}
</style>
